"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var CopyButton_1 = __importDefault(require("../CopyButton"));

var Hash_1 = __importDefault(require("./Hash"));

var get_1 = __importDefault(require("lodash/get"));

var Heuristic = function Heuristic(_a) {
  var name = _a.name,
      value = _a.value;
  return value && react_1.default.createElement("div", {
    className: 'col'
  }, react_1.default.createElement("p", null, name), react_1.default.createElement("h4", {
    className: 'text-success'
  }, value));
};

var Heuristics = function Heuristics(_a) {
  var heuristics = _a.heuristics;
  return react_1.default.createElement("div", {
    className: 'row mb-2'
  }, react_1.default.createElement(Heuristic, {
    name: 'Index',
    value: (get_1.default(heuristics, 'index') || '').toString()
  }), react_1.default.createElement(Heuristic, {
    name: 'RSSI',
    value: (get_1.default(heuristics, 'rssi') || '').toString()
  }), react_1.default.createElement(Heuristic, {
    name: 'Latitude',
    value: (get_1.default(heuristics, 'gps.latitude') || '').toString()
  }), react_1.default.createElement(Heuristic, {
    name: 'Longitude',
    value: (get_1.default(heuristics, 'gps.longitude') || '').toString()
  }));
};

exports.CopyHash = function (_a) {
  var value = _a.value;
  return react_1.default.createElement("div", {
    className: 'd-flex align-items-center mb-2'
  }, react_1.default.createElement(Hash_1.default, {
    value: react_1.default.createElement("strong", null, value),
    size: 20,
    className: 'text-secondary'
  }), react_1.default.createElement("div", {
    className: 'col'
  }), react_1.default.createElement(CopyButton_1.default, {
    value: value,
    className: 'border'
  }));
};

exports.default = function (_a) {
  var className = _a.className,
      _b = _a.boundWitness,
      hash = _b.hash,
      parties = _b.parties;
  return react_1.default.createElement("div", {
    className: className
  }, react_1.default.createElement("p", null, "Hash"), react_1.default.createElement("div", {
    className: 'bg-light d-flex p-3 rounded align-items-center mb-4'
  }, react_1.default.createElement(Hash_1.default, {
    value: hash,
    size: 20
  }), react_1.default.createElement("div", {
    className: 'col'
  }), react_1.default.createElement(CopyButton_1.default, {
    value: hash,
    className: 'border'
  })), react_1.default.createElement("div", {
    className: 'row'
  }, react_1.default.createElement("div", {
    className: 'col-12'
  }, (parties || []).map(function (party, i) {
    return react_1.default.createElement("div", {
      className: 'card shadow-sm mb-2',
      key: i
    }, react_1.default.createElement("div", {
      className: 'card-header bg-white'
    }, "Party ", i + 1), react_1.default.createElement("div", {
      className: 'card-body'
    }, react_1.default.createElement("p", {
      className: 'mb-0'
    }, "Public Key"), react_1.default.createElement(exports.CopyHash, {
      value: get_1.default(party, 'publicKey')
    }), get_1.default(party, 'heuristics.previousHash') ? react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("p", {
      className: 'mb-0'
    }, "Previous Hash"), react_1.default.createElement(exports.CopyHash, {
      value: get_1.default(party, 'heuristics.previousHash')
    })) : '', react_1.default.createElement(Heuristics, {
      heuristics: get_1.default(party, 'heuristics')
    })));
  }))));
};